import { useWriteTab } from "@erp/shared/components/ui/Document/_composable/useWriteTab";
import { defineStore } from "pinia";
export const useEstimateWriteTabStore = defineStore("estimateWriteTab", useWriteTab);
